"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _dotted = require("./lib/dotted");

exports["default"] = _dotted.dotted;